import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import {consume} from '@lit-labs/context';
import {SessionContext} from '#lit/contexts/session.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import type {ImpersonationOptions} from './utils.js';
import styles from './style.scss';

export const IMPERSONATOR_ELEMENT_TAG = 'fly-impersonator';

/**
 * Component for handling user impersonation.
 */
@customElement(IMPERSONATOR_ELEMENT_TAG)
export default class Impersonator extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @consume({context: SessionContext, subscribe: true})
  @property({type: Object})
  get session() {
    return this.model.session ?? undefined;
  }
  set session(session) {
    this.handleUpdate(Msg.setSession(session ?? null));
  }

  @property({type: Array})
  options: ImpersonationOptions = [];

  @property({type: Number, attribute: 'current_user_id'})
  currentUserId = 0;

  @property({type: Number, attribute: 'current_team_id'})
  currentTeamId = 0;

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [IMPERSONATOR_ELEMENT_TAG]: Impersonator;
  }
}
